const toFixed = (number, decimalDigit) => {
  try {
    if (typeof number !== 'number' && typeof number !== 'string') {
      return null;
    }
    if (
      number !== '' &&
      typeof decimalDigit === 'number' &&
      decimalDigit >= 0 &&
      decimalDigit <= 100
    ) {
      const numericValue = Number(number);
      return isNaN(numericValue) ? null : numericValue.toFixed(decimalDigit);
    }
    return null;
  } catch (_) {
    return null;
  }
};

export default toFixed;
